import { React, useContext } from "react";
import ThemeContext from "../../lib/theme-context";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

const CustomDateTimePicker = ({ label, value, onChange, size, border }) => {
  const theme = useContext(ThemeContext);

  return (
    <DateTimePicker
  
      size={size}
      sx={{
        "& label": {
          color:
            theme[0] === "dark"
              ? "#FCFCFF !important"
              : "rgba(37,37,37) !important",
        },

        width: "100%",
        height: "50px",

        "& fieldset": {
          border: border,
          // - The <fieldset> inside the Input-root
          borderColor: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)", // - Set the Input border
        },
        "&:hover fieldset": {
          borderColor: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)", // - Set the Input border when parent has :hover
        },
        "&.Mui-focused fieldset": {
          // - Set the Input border when parent is focused
          borderColor: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
        },

        input: {
          color: theme[0] === "dark" ? "#FCFCFF" : "black",
        },
      }}
      slotProps={{
        textField: { size: size },
        popper: { 
          placement: "auto",
          sx: {
            zIndex: 99999,
            "& .MuiPaper-root": {
              backgroundColor: theme[0] === "dark" ? "#1e1e1e" : "#ffffff",
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersDay-root": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
              "&:hover": {
                backgroundColor: theme[0] === "dark" ? "rgba(252, 252, 255, 0.1)" : "rgba(0, 0, 0, 0.04)",
              },
            },
            "& .MuiPickersDay-root.Mui-selected": {
              backgroundColor: theme[0] === "dark" ? "#0079cf" : "#1976d2",
            },
            "& .MuiPickersCalendarHeader-label": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersCalendarHeader-labelContainer .MuiSvgIcon-root": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersArrowSwitcher-button": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiDayCalendar-weekDayLabel": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiClock-pin": {
              backgroundColor: theme[0] === "dark" ? "#0079cf" : "#1976d2",
            },
            "& .MuiClockPointer-root": {
              backgroundColor: theme[0] === "dark" ? "#0079cf" : "#1976d2",
            },
            "& .MuiClockPointer-thumb": {
              backgroundColor: theme[0] === "dark" ? "#0079cf" : "#1976d2",
              borderColor: theme[0] === "dark" ? "#0079cf" : "#1976d2",
            },
            "& .MuiClockNumber-root": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersYear-yearButton": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersYear-yearButton.Mui-selected": {
              backgroundColor: theme[0] === "dark" ? "#0079cf" : "#1976d2",
            },
            "& .MuiDialogActions-root button": {
              color: theme[0] === "dark" ? "#FCFCFF" : "#1976d2",
            },
          },
        },
      }}
      slots={{
        openPickerIcon: () => (
          <CalendarMonthIcon
            sx={{
              color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
            }}
          />
        ),
      }}
      label={label}
      value={value ? dayjs(new Date(value)) : dayjs(new Date())}
      onChange={onChange}
    />
  );
};

export default CustomDateTimePicker;
